import script from "./group_user_page.vue?vue&type=script&setup=true&lang=js"
export * from "./group_user_page.vue?vue&type=script&setup=true&lang=js"

import "./group_user_page.vue?vue&type=style&index=0&id=fbd53aee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbd53aee"]])

export default __exports__